import { Types } from './types'

const initialState = {
    dataTimeWork: {
        rows: []
    },
    currentRecord: null
}
const timeWorkReducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_TIME_WORK:
            return {
                ...newState,
                dataTimeWork: action.payload
            }
        default:
            return { ...newState }
    }
}
export default timeWorkReducer
